import { useCallback, useState, useEffect } from 'react';

export const useResendVerifyEmail = () => {
  const [loading, setLoading] = useState(false);
  const [countDown, setCountDown] = useState(0);

  useEffect(() => {
    let timer;
    if (countDown > 0) {
      timer = setTimeout(() => {
        setCountDown(countDown - 1);
      }, 1000);
    }
    return () => clearTimeout(timer);
  }, [countDown]);

  const resendVerifyEmail = useCallback(async () => {
    try {
      setLoading(true);
      const response = await fetch('/api/user/resend-verification-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
      });
      if (response.ok) {
        setCountDown(60);
        const data = await response.json();
        return data.data;
      } else {
        throw new Error(await response.json());
      }
    } catch (error) {
      setCountDown(0);
      console.log('Send verification email failed', error);
    } finally {
      setLoading(false);
    }
  }, []);

  return { resendVerifyEmail, countDown, loading };
};
